import React from 'react';
import PropTypes from 'prop-types';

import PhoneIcon from '../../../assets/icon-phone-brown-filled.svg';
import EmailIcon from '../../../assets/icon-email-brown-filled.svg';
import { useTooltip } from '../../hooks';

import styles from '../../styles/views/components/Contacts.module.scss';

export default function UserContacts({
  phoneNumber,
  email,
  classes,
  isEmailDetailsVisible,
  isPhoneDetailsVisible,
}) {
  useTooltip();

  return (
    <div className={[styles.contacts, classes.wrapper].join(' ')}>
      <div className={styles.phone}>
        {phoneNumber ? (
          <a onClick={e => e.stopPropagation()} href={`tel:${phoneNumber}`}>
            <PhoneIcon />
            {isPhoneDetailsVisible && <span className={styles.info} data-tip={phoneNumber}>{phoneNumber}</span>}
          </a>
        ) : null}
      </div>
      <div className={[styles.email, classes.email].join(' ')}>
        {email ? (
          <a onClick={e => e.stopPropagation()} href={`mailto:${email}`}>
            <EmailIcon />
            {isEmailDetailsVisible && <span className={styles.info} data-tip={email}>{email}</span>}
          </a>
        ) : null}
      </div>
    </div>
  );
}

UserContacts.propTypes = {
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    email: PropTypes.string,
  }),
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  isEmailDetailsVisible: PropTypes.bool,
  isPhoneDetailsVisible: PropTypes.bool,
};

UserContacts.defaultProps = {
  classes: {},
  phoneNumber: '',
  email: '',
  isEmailDetailsVisible: false,
  isPhoneDetailsVisible: false,
};
